import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import UserAppResource from './UserAppResource';
import LandingPageAppResource from './LandingPageAppResource';

class LandingPageEmailBlastAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'landing-page-email-blast';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'landings/pages/emails/blasts';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'landingPageUuid',
      'landingPage',
      'userUuid',
      'subject',
      'message',
      'contacts',
      'createdAt',
      'updatedAt',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      user: UserAppResource,
      landingPage: LandingPageAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      user: 'user_uuid',
      landingPage: 'landing_page_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      landingPageUuid: {
        type: 'string',
        presence:                 true,
      },
      userUuid: {
        type: 'string',
        presence:                 true,
      },
      subject: {
        type: 'string',
        presence:                 true,
        length: {
          maximum: 255,
        },
      },
      message: {
        type: 'string',
        presence:                 true,
        length: {
          maximum: 5000,
        },
      },
      contacts: {
        presence:                 true,
      },
    };
  }

}

export default LandingPageEmailBlastAppResource;
